import { getProductJson } from '../product-page/helpers';

const storage_name = 'wild-recently-views-products';

const extractRecentlyViewedProducts = () => {
  // let cookie_values = Cookies.get(storage_name);
  let cookie_values = window.localStorage.getItem(storage_name);
  if (typeof cookie_values === 'undefined') {
    cookie_values = [];
  }

  let products_json = JSON.parse(cookie_values);

  if (document.querySelector('[data-product-json]')) {
    const product = getProductJson();

    // Remove current product from returned recent products
    products_json = products_json.filter(recent_product => recent_product.handle !== product.handle);

    products_json.reverse();
  }

  // Only show the items using the same currency as the cart
  products_json = products_json.filter(recent_product => {
    if (typeof recent_product.currency_cart === 'undefined') {
      recent_product.currency_cart = window.theme.currency;
    }
    return recent_product.currency_cart === window.theme.currency_cart;
  });

  return products_json;
};

const saveRecentlyViewedCookie = () => {
  if (!$('[data-product-json]').length) {
    return;
  }

  const product = getProductJson();

  let cookie_values = window.localStorage.getItem(storage_name);
  // console.log('cookie_values', cookie_values);

  if (cookie_values === null || !cookie_values.length) {
    cookie_values = [];
  }

  if (cookie_values.length) {
    cookie_values = JSON.parse(cookie_values);
  }

  // In case the cookie has been altered for some reasons
  if (!Array.isArray(cookie_values)) {
    cookie_values = [];
  }

  // Do not add if product is already in history
  if (cookie_values.some(item => item.handle === product.handle)) {
    return;
  }

  // We reached the max products allowed, make room by removing the oldest one
  const maxProducts = Number(document.querySelector('[data-recently-viewed-products-slider]').getAttribute('data-recently-viewed-products-max'));
  if (cookie_values.length >= maxProducts) {
    cookie_values.shift(); // removes the first item
  }

  cookie_values.push({
    title: product.title,
    handle: product.handle,
    featured_image: product.featured_image,
    price: Number(product.price / 100).toFixed(2),
    price_min: Number(product.price_min / 100).toFixed(2),
    price_max: Number(product.price_max / 100).toFixed(2),
    compare_at_price: Number(product.compare_at_price / 100).toFixed(2),
    currency_cart: window.theme.currency_cart,  // only show the items using the same currency as the cart
  });

  // Cookies.set(storage_name, cookie_values);
  window.localStorage.setItem(storage_name, JSON.stringify(cookie_values));
};

export {
  saveRecentlyViewedCookie,
  extractRecentlyViewedProducts
};
